import React from 'react';
import propTypes from 'prop-types';

export const MaleIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      width={sizeInPixel}
      height={sizeInPixel}
      className={variant}
      fill={color}
      viewBox="0 0 50 50"
      version="1.2"
      baseProfile="tiny"
      xmlns="http://www.w3.org/2000/svg"
      overflow="inherit"
    >
      <path d="M18 47c0 1.233.768 2 2 2 1.235 0 2-.767 2-2v-19h2v19c0 1.231.767 2 2 2s2-.767 2-2v-32h1v11.814c0 2.395 3.006 2.395 3 0v-12.153c0-2.646-1.906-4.661-5-4.661h-8c-2.82 0-5 1.719-5 4.587v12.413c0 2 3 2 3 0v-12h1v32z" />
      <circle cx="22.875" cy="4.625" r="4.125" />
    </svg>
  );
};
MaleIcon.propTypes = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
MaleIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
